import React from 'react'
import { ContrastFormattedMessage } from '../contrast-formatted-message'
import { LinkButton } from '../../design-system'

export function ToggleToOldDashboard({
  onClick
}: {
  readonly onClick: () => void
}) {
  return (
    <ContrastFormattedMessage id="action_dashboardReturnToOriginalDashboard">
      {(msg) => <LinkButton children={msg} onClick={() => onClick()} />}
    </ContrastFormattedMessage>
  )
}
